const countries = [
  '',
  'Argentina',
  'Australia',
  'Belgium',
  'Bulgaria',
  'Canada',
  'Chile',
  'China',
  'Colombia',
  'Denmark',
  'Dubai',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'India',
  'Indonesia',
  'Ireland',
  'Italy',
  'Japan',
  'Mexico',
  'The Netherlands',
  'New Zealand',
  'Norway',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Russia',
  'Singapore',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland',
  'Turkey',
  'United Kingdom',
  'United States',
];

export default countries;
